import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const MOBILE_LINK_CLASS =
    "inline-flex min-h-[44px] items-center border-0 bg-transparent p-0 text-left text-sm font-medium " +
    "text-[#5D5DF6] underline decoration-[#5D5DF6] decoration-solid underline-offset-[3px] " +
    "hover:text-[#4848E6] hover:decoration-[#4848E6] disabled:cursor-not-allowed disabled:opacity-50";

const SettingsEditLink = ({ onClick, disabled, loading, label, mobileLabel, desktopLabel }) => {
    const { t } = useTranslation("settings");

    const resolvedDesktopLabel = desktopLabel ?? label ?? t("editInformation");
    const resolvedMobileLabel = mobileLabel ?? label ?? t("editDetails");

    return (
        <>
            <button
                type="button"
                className={`${MOBILE_LINK_CLASS} lg:hidden`}
                onClick={onClick}
                disabled={disabled || loading}>
                {resolvedMobileLabel}
            </button>
            <Button
                type="primary"
                shape="round"
                onClick={onClick}
                disabled={disabled}
                loading={loading}
                className="hidden lg:inline-flex">
                {resolvedDesktopLabel}
            </Button>
        </>
    );
};

SettingsEditLink.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    /** Used for both breakpoints when desktopLabel/mobileLabel omitted */
    label: PropTypes.string,
    mobileLabel: PropTypes.string,
    desktopLabel: PropTypes.string,
};

SettingsEditLink.defaultProps = {
    disabled: false,
    loading: false,
    label: undefined,
    mobileLabel: undefined,
    desktopLabel: undefined,
};

export default SettingsEditLink;
